import React from 'react'
import { Link, useParams } from 'react-router'
import ExpenseSetting from '../Settings/ExpenseSetting'
import styles from './ExpensesNavigator.module.css'

const ExpensesNavigator = () => {
    const { activeIdentifier } = useParams()
    return (
        <div>
            <div className={styles.headerWrapper}>
                <div className={styles.allTitles}>
                    <Link to={`/expenses/all`} className={activeIdentifier === 'all' ? styles.eachActiveTitle : styles.eachTitle}
                    >
                        All Expenses
                    </Link>
                    <Link to={`/expenses/reports`} className={activeIdentifier === 'reports' ? styles.eachActiveTitle : styles.eachTitle}
                    >
                        Reports
                    </Link>
                    <Link to={`/expenses/budget`} className={activeIdentifier === 'budget' ? styles.eachActiveTitle : styles.eachTitle}
                    >
                        Budget
                    </Link>
                    <Link to={`/expenses/approvals`} className={activeIdentifier === 'approvals' ? styles.eachActiveTitle : styles.eachTitle}
                    >
                        Approvals
                    </Link>
                    <Link to={`/expenses/settings`} className={activeIdentifier === 'settings' ? styles.eachActiveTitle : styles.eachTitle}
                    >
                        Settings
                    </Link>
                </div>

            </div>
            <div className={styles.mainBody}>
                {activeIdentifier==='settings' && <ExpenseSetting /> }
            </div>
        </div >
    )
}

export default ExpensesNavigator